import {
  FETCH_ALL_FILTER_PRODUCT_LIST,
  FETCH_ALL_MULTISLOT_CONTENT_LIST,
  FETCH_ALL_ECOM_PRODUCT_CONTENT_LIST,
} from "../../graphQL/queries/contentGalleryQueries";

export const fetchAllFilterProductList = FETCH_ALL_FILTER_PRODUCT_LIST;
export const fetchAllMultislotContentList = FETCH_ALL_MULTISLOT_CONTENT_LIST;
export const fetchAllEcomProductContentList = FETCH_ALL_ECOM_PRODUCT_CONTENT_LIST;
